<template>
  <div>
    <div
      class="hi-lo-number-bet-lot-cell"
      :class="{ 'hi-lo-number-bet-lot-cell-active': win, [size]: size }"
    >
      <Row
        class="hi-lo-number-bet-lot-title"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
        align="middle"
      >
        <span v-html="$t(`hi_lo.${type}_trend`)"></span>
      </Row>
      <Row
        class="hi-lo-number-bet-lot-bet-no"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
      >{{ odd }}</Row>
      <div v-if="stakeRecordSum" class="hi-lo-number-bet-lot-stake-total">{{ stakeRecord }}</div>
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum"],
  components: {
    Row
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    }
  }
};
</script>

<style lang="scss" scoped>
.hi-lo-number-bet-lot-cell {
  position: relative;
  padding: 2px 0 3px;
  width: 100%;
  border-radius: 4px;
  background: #2a2a2b;
  text-align: center;
  cursor: pointer; //1017 ADDED
}

.hi-lo-number-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.hi-lo-number-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.hi-lo-number-bet-lot-title {
  color: #dcad58;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  margin: 0 8px;
  line-height: 1.5;
  font-size: 12px;
}

.hi-lo-number-bet-lot-title.small {
  height: unset;
}

.hi-lo-number-bet-lot-bet-no {
  @extend .tai-xiu-game-bet-no;
  height: 20%;
}

.hi-lo-number-bet-lot-bet-no.small {
  height: unset;
}

// hi-lo-number-bet-lot-title ivu-row-flex ivu-row-flex-middle ivu-row-flex-center small

.hi-lo-number-bet-lot-cell-active .hi-lo-number-bet-lot-title,
.hi-lo-number-bet-lot-cell-active .hi-lo-number-bet-lot-bet-no {
  @extend .tai-xiu-game-btn-active;
}
</style>

<style lang="scss">
.hi-lo-number-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

@media only screen and (max-width: 360px) {
  .hi-lo-number-bet-lot-cell {
    padding: 6px 0;
  }

  .hi-lo-number-bet-lot-cell.large {
    padding-bottom: 6px;
  }

  // .hi-lo-number-bet-lot-title.large {
  //   height: 32px;
  // }

  // .hi-lo-number-bet-lot-bet-no.large,
  // .hi-lo-number-bet-lot-bet-no.small {
  //   margin-top: 6px;
  // }
}
</style>
